module.exports = __webpack_public_path__ + "static/media/hammer-war.45654a1a.svg";